import { MESSAGE } from '@vindr/services/constants/message.constant';
import { Form, Select } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import TagInput from '../../../ui/TagInput';
import { FormItemProps } from '../templates/FormProps';

export type FormTagInput = Parameters<typeof Select>[0] &
  FormItemProps & {
    message: Parameters<typeof TagInput>['0']['message'];
  };

const FormTagInput = ({
  name,
  label,
  placeholder,
  rules,
  disabled,
  required,
  className,
  noStyle,
  message,
  ...props
}: FormTagInput): JSX.Element => {
  const { t } = useTranslation('Vindoc');

  const rulesMemo = useMemo(() => {
    const rulesState = [];

    if (required) {
      rulesState.push({
        required: true,
        message: t(MESSAGE.INLINE.IEM_0001),
      });
    }

    if (rules) rulesState.push(...rules);

    return rulesState;
  }, [t, required, rules]);

  return (
    <Form.Item
      name={name}
      {...(label && { label: t(label) })}
      rules={rulesMemo}
      className={className}
      noStyle={noStyle}
      required={required}
    >
      <Select mode="tags" placeholder={t(placeholder)} disabled={disabled} {...props} />
    </Form.Item>
  );
};

export default FormTagInput;
